import React from 'react';
import { useRightColumnContext } from 'Context/RightColumnContext';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import getTemplate from './Templates';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1),
  },
}));


const RightColumnContent = () => {
  const { rightColumnCollection } = useRightColumnContext();
  const { template: Component } = getTemplate(rightColumnCollection);
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Component />
    </Box>
  );
};

export default RightColumnContent;
